import i18n from '@/i18n';

export function requiredRule(value) {
  return !!value || i18n.t('rules.empty');
}

export function cardNoRule(value) {
  return !value || String(value).length == 20 || i18n.t('rules.cardNo');
}

export function avsNoRule(value) {
  return (
    !value ||
    (value >= 7560000000001 && value <= 7569999999999) ||
    i18n.t('rules.avsNo')
  );
}

export function phonePrefixRule(value) {
  if (!value) return true;
  const pattern =
      /^\d{1,5}$/;
  return pattern.test(value.replace(/\s/g, "")) || i18n.t('rules.phonePrefix');
}

export function phoneRule(prefix, number) {
  if (!number) return true;
  if (prefix === "41") {
    const pattern =
        /^(0\d{9}|[1-9]\d{8})$/;
    return pattern.test(number.replace(/\s/g, "")) || i18n.t('rules.phone');
  } else {
    const pattern =
        /^(\d{4,14})$/;
    return pattern.test(number.replace(/\s/g, "")) || i18n.t('rules.phone');
  }

}

export function emailRule(value) {
  if (!value) return true;
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(value) || i18n.t('rules.email');
}
